import { _,Backbone,moment } from '../../vendor'
import { Biscuit } from '../utils'
import Reservations from '../collections/Reservations'

import InboomaBaseModel from './InboomaBaseModel'
import { getApiHost } from '../Sync'

const Order = InboomaBaseModel.extend({

    urlRoot : '/orders',
    type: 'orders',

    _rbac : {
      "admin" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "edit-status" : true,
        "remove" : true,
        "can_make_payment": true,
        "filter_by_user" : true,
        "filter_by_tag" : true,
        "filter_by_contingent" : true,
        "filter_by_location" : true,
        "order_export_contract" : true,
        "viewReservationsList" : true,
        "viewOrders" : true
      },
        "user" : {
            "read" : true,
            "write" : false,
            "edit" : false,
            "edit-status" : false,
            "remove" : false,
            "can_make_payment": false,
            "filter_by_user" : false,
            "filter_by_contingent" : false,
            "filter_by_location" : false,
            "filter_by_tag" : false,
            "order_export_contract" : false,
            "viewReservationsList" : false,
            "viewOrders" : true
        },
        "mediator" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "edit-status" : false,
            "remove" : false,
            "can_make_payment": false,
            "filter_by_user" : false,
            "filter_by_contingent" : false,
            "filter_by_location" : false,
            "filter_by_tag" : true,
            "order_export_contract" : false,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
        "garage-staff" : {
          "read" : true,
          "write" : false,
          "edit" : false,
          "edit-status" : false,
          "remove" : false,
          "can_make_payment": false,
          "filter_by_user" : false,
          "filter_by_contingent" : false,
          "filter_by_location" : false,
          "filter_by_tag" : false,
          "order_export_contract" : false,
          "viewReservationsList" : true,
          "viewOrders" : true
        },
        "guide" : {
            "read" : true,
            "write" : true,
            "edit" : true,
            "edit-status" : false,
            "remove" : false,
            "can_make_payment": false,
            "filter_by_user" : false,
            "filter_by_contingent" : false,
            "filter_by_location" : false,
            "filter_by_tag" : true,
            "order_export_contract" : false,
            "viewReservationsList" : true,
            "viewOrders" : true
        },
      "manager" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "edit-status" : true,
        "remove" : false,
        "can_make_payment": true,
        "filter_by_user" : true,
        "filter_by_tag" : true,
        "filter_by_contingent" : true,
        "filter_by_location" : true,
        "order_export_contract" : true,
        "viewReservationsList" : true,
        "viewOrders" : true
      },
      "booking-manager" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "edit-status" : true,
        "remove" : false,
        "can_make_payment": true,
        "filter_by_user" : true,
        "filter_by_tag" : true,
        "filter_by_contingent" : true,
        "filter_by_location" : true,
        "order_export_contract" : true,
        "viewReservationsList" : true,
        "viewOrders" : true
      },
      "manager-location" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "edit-status" : true,
        "remove" : false,
        "can_make_payment": true,
        "filter_by_user" : true,
        "filter_by_tag" : true,
        "filter_by_contingent" : true,
        "filter_by_location" : true,
        "order_export_contract" : true,
        "viewReservationsList" : true,
        "viewOrders" : true
      },

    },

    initialize () {

        this.setReservationsCollection()
            .setTimespan();

        this.on('change:reservations', (that) => {
            that.setReservationsCollection();
        });

        InboomaBaseModel.prototype.initialize.apply(this);
    },

    /**
     * @public
     * @method setReservationsCollection
     * @return {instance}
     * Transform reservations attribute into (much more useful)
     * Backbone.Collection
     */
    setReservationsCollection () {

        if (typeof this.attributes.reservations.models === 'undefined') {

            const reservationsCollection = new Reservations(this.attributes.reservations);

          /* _.each(this.attributes.reservations, (reservation) => {
                if (typeof reservation !== 'string') {
                    reservationsCollection.add(reservation);
                }
            });*/

            this.set('reservations', reservationsCollection);

        }

        return this;
    },

    /**
     * @public
     * @method setTimespan
     * @return {instance}
     * 
     * Iterates through child reservations, estimates lowest
     * "from" and highest "to" date of this order and sets it privately.
     * 
     * Note that as we're calling in "moment", this is a potential performance bottleneck
     */
    setTimespan () {

        let timespan_begin = '',
            timespan_end = '';
        
        _.each(this.get('reservations').models, (reservation, key) => {
                
          if ((reservation.get('begin') == '' || _.isNull(reservation.get('begin'))) &&
              (reservation.get('end') == '' || _.isNull(reservation.get('end')))) {
                return;
          }

          // Add earliest & latest booking timestamp to order
          if (timespan_begin == '' && (reservation.get('begin') != '' && !_.isNull(reservation.get('begin')))) {
              timespan_begin = moment(reservation.get('begin'));
          }
          if (timespan_end == '' && (reservation.get('end') != '' && !_.isNull(reservation.get('end')))) {
              timespan_end = moment(reservation.get('end'));
          }
          if (reservation.get('begin') !== '') {
              if (moment(reservation.get('begin')).isSameOrBefore(timespan_begin)) {
                  timespan_begin = moment(reservation.get('begin'));
              }
          }
          if (reservation.get('end')) {
              if (moment(reservation.get('end')).isSameOrAfter(timespan_end)) {
                  timespan_end = moment(reservation.get('end'));
              }
          }
        });

        if (typeof timespan_begin !== 'undefined' && timespan_begin !== '' && !_.isNull(timespan_begin)) {
            this.set('timespan_begin', timespan_begin);
        }
        if (typeof timespan_end !== 'undefined' && timespan_end !== '' && !_.isNull(timespan_end)) {
            this.set('timespan_end', timespan_end);
        }

        return this;
    },

    // Overrides Backbone.save in order to extract
    // local _hasAppointments
    save (key, val, options) {

        delete this.attributes._hasAppointments;

        const result = Backbone.Model.prototype.save.call(this, key, val, options);

        // change also reservation status in case of "confirmed" or "cancelled"
        if (key.status === 'confirmed' || key.status === 'cancelled') {

          _.each(this.attributes.reservations.models,(res) => {       // also change status of reservations in case of cancelled
            res.set('status',key.status);
            res.trigger('change');
          });
        }

       return result;
      
    },

    get (attr) {

      if (attr == 'price') {
          if (this.attributes.price != null) {
              if (this.attributes.price.toString().indexOf(',') < 0) {
              // || this.model.set('price', Number(this.model.get('price')).toLocaleString("de-DE", {minimumFractionDigits: 2}) + '€');
              return Number(this.attributes.price).toFixed(2).replace('.',',') + Biscuit.getClientCurrency(); 
            } else {
              return this.attributes.price;
            }
          } else {
            return '0,00' + Biscuit.getClientCurrency();
          }
      } else {
          // Backbone.js -> l441
          return this.attributes[attr];
      }

    },

    updatePrice (successCallback = _.noop) {
      
      const that = this;

      (new Order({ id : this.get('id') })).fetch({
        success (model, response) {
            model.set('price', response.data.price); // needed for formatting

            that.set('price', model.get('price'))
                .set('modified', model.get('modified'))
                .set('modified_by', model.get('modified_by'));
                
            successCallback();
        }
      });
    },

    /**
     * Updates order status to "confirmed", updates all reservations status
     * to "confirmed" (locally), send "order executed" response.
     * 
     * @return Promise
     */
    executeOrder () {

      const that = this,
            RequestHelper = Backbone.Model.extend({ urlRoot : '/orders' }),
            o_id = Number(this.get('id'));

      return new Promise(
        (resolve, reject) => {
          (new RequestHelper()).save(
              { 
                id : o_id,
                status : "confirmed" 
              },{
                type: 'PATCH',
                success (model, response) {

                    that.set('status', "confirmed");

                    // Some status types trigger changes on child reservations
                    _.each(that.get('reservations').models, (reservation) => {
                        reservation.set({ status : 'confirmed' }, { silent : true });
                    });

                    that.sendExecuted()
                      .then((_response) => {
                          resolve(_response);
                      })
                      .catch((_error) => {
                          reject(_error);
                      });

                },
                error (model, response) {
                    console.log("Error, could not save status == confirmed.");
                    reject('Cound not update order status to "confirmed"');
                }
              });
        }
      );

    },

    /**
     * Sends an empty "execute order" request to send updated order details
     * as mail to customer.
     */
    sendExecuted () {

      const RequestHelper = Backbone.Model.extend({ urlRoot : '/orders/execute' });

      const o_id = Number(this.get('id'));

      return new Promise(
        (resolve, reject) => {
          (new RequestHelper()).save(
              { 
                id : o_id,
              },{
                type: 'POST',
                success (model, response) {
                    resolve(response);  
                },
                error (model, response) {
                    console.log("Error, could not execute order.");
                    reject('Could not execute order');
                }
              });
        }
      );
    },

    submitOrderStatus() {

        return this.sendMail(JSON.stringify(
          {
            "template_type":"Order", 
            "settings":{ "order_id": this.get("id") }
          }
        ));
    },

    sendMail(content) {

      // @todo Refactor using native Backbone model approach
      //       -> @see https://bitbucket.org/inbooma_dev/inbooma2_ui/src/eddc6b582af6e85c38e7beb0143bce640f81d024/docs/API_REQUESTS.md

      return new Promise(function(resolve, reject) {
      
        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("POST", getApiHost() + '/messages/sendMail');
  
        xmlHttp.setRequestHeader('Accept', 'application/json');
        xmlHttp.setRequestHeader('Content-Type', 'application/json');
        xmlHttp.setRequestHeader('Authorization', "Bearer " + Biscuit.get('token'));      // Bearer as necessary convention for tokens
        xmlHttp.onload = function() {
  
          if (xmlHttp.status === 200) {
            resolve(xmlHttp.response);
          } else {
            reject(Error(xmlHttp.statusText));
          }
        };

        xmlHttp.send(content);
      });
    },

    paymentList(orderId) {

      const that = this;
      if (orderId) {

        (new Order({
          id: orderId
        })).fetch({
          success(model, response) {
            model.set('order_id', response.data.order_id); // needed for formatting
            that.set('order_id', model.get('order_id'));
          }
        });
      } else {
        // Backbone.js -> l441
        return this.attributes[orderId];
      }

    },

    getReservation : id => 
      _.find(
              this.get('reservations').models,
              reservation => reservation.get('id') == id
            )
    ,

    /** stati:
Orders [requested, confirmed, paid, cancelled]
Resources [active, inactive, defect]
 */

    defaults : {
      id : "",
      client_id : "",
      order_nbr : 0,
      description : "",
      user_id : "",
      executed : "",
      price : "0",
      status : "requested",
      form_data: "",
      reservations : [],
      wallet_transactions : [],
      timespan_begin : "",
      timespan_end : "",
      created : "",
      modified : "",
      deleted : "",
      created_by: "",
      modified_by: "",
      _hasAppointments : [],
      order_addresses: [],
      tasks: [],
      types: null,
      waiveRightOfWithdrawal: null,
      readRightOfWithdrawal: null
    }
});

export default Order;
